import Vue from 'vue';

var A = "A".charCodeAt(0);
var Z = "Z".charCodeAt(0);
var diffToLC = "a".charCodeAt(0) - A;
var isUpperCase = function (c) { return c >= A && c <= Z; };
var toLC = function (c) {
    return String.fromCharCode(c + diffToLC);
};
var isVendorPrefix = function (s) {
    return s.indexOf("webkit") == 0 || s.indexOf("moz") == 0 || s.indexOf("ms") == 0;
};
function CamelToKebab(str) {
    var xform = "";
    var len = str.length;
    var code = 0;
    if (isVendorPrefix(str)) {
        xform += "-";
    }
    for (var i = 0; i < len; i++) {
        code = str.charCodeAt(i);
        if (isUpperCase(code)) {
            xform += "-" + toLC(code);
            continue;
        }
        xform += str[i];
    }
    return xform;
}

function mqo2str(mqo) {
    var feat;
    var val;
    var mq = [];
    for (var _i = 0, _a = Object.keys(mqo); _i < _a.length; _i++) {
        feat = _a[_i];
        val = mqo[feat];
        feat = CamelToKebab(feat);
        if (val === true) {
            mq.push(feat);
            continue;
        }
        if (val === false) {
            mq.push("not " + feat);
            continue;
        }
        mq.push("(" + feat + ": " + val + ")");
    }
    return mq.join(" and ");
}
function toMQS() {
    var mqos = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mqos[_i] = arguments[_i];
    }
    return mqos.map(mqo2str).join(", ");
}
function FlattenMediaQueryMap(map) {
    var flat = Object.create(null);
    var alias;
    var mqo;
    for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
        alias = _a[_i];
        mqo = map[alias];
        if (!Array.isArray(mqo)) {
            mqo = [mqo];
        }
        flat[alias] = toMQS.apply(void 0, mqo);
    }
    return flat;
}

var compat = {
    useFallback: false,
};
{
    var mql = window.matchMedia("(min-width: 1px)");
    compat.useFallback = typeof mql.addEventListener !== "function";
}
function SubscribeToMediaQuery(query, listener) {
    var mql = window.matchMedia(query);
    var unsubscribe = function () {
        if (compat.useFallback) {
            mql.removeListener(listener);
        }
        else {
            mql.removeEventListener("change", listener);
        }
    };
    if (compat.useFallback) {
        mql.addListener(listener);
    }
    else {
        mql.addEventListener("change", listener);
    }
    listener(mql);
    return unsubscribe;
}

var Bootstrap4Grid = function () { return ({
    xsUp: { minWidth: "0px" },
    xsDown: { maxWidth: "575px" },
    xsOnly: { maxWidth: "575px" },
    smUp: { minWidth: "576px" },
    smDown: { maxWidth: "767px" },
    smOnly: { minWidth: "576px", maxWidth: "767px" },
    mdUp: { minWidth: "768px" },
    mdDown: { maxWidth: "991px" },
    mdOnly: { minWidth: "768px", maxWidth: "991px" },
    lgUp: { minWidth: "992px" },
    lgDown: { maxWidth: "1199px" },
    lgOnly: { minWidth: "992px", maxWidth: "1199px" },
    xlUp: { minWidth: "1200px" },
}); };

var BreakpointComponent = Vue.extend({
    name: "breakpoint",
    props: {
        breakpointMap: {
            required: true,
            type: Object,
            default: Bootstrap4Grid,
        },
    },
    data: function () {
        return {
            subscriptions: [],
            activeMap: Object.keys(this.breakpointMap).reduce(function (map, alias) {
                map[alias] = false;
                return map;
            }, {}),
        };
    },
    watch: {
        flatMap: function () {
            this.unsubscribe();
            this.initMediaQueries();
        },
    },
    computed: {
        flatMap: function () {
            return FlattenMediaQueryMap(this.breakpointMap);
        },
        context: function () {
            return Object.assign({}, this.activeMap);
        },
    },
    methods: {
        initMediaQueries: function () {
            var _this = this;
            var _loop_1 = function (alias) {
                this_1.subscriptions.push(SubscribeToMediaQuery(this_1.flatMap[alias], function (mql) {
                    if (!mql.matches) {
                        _this.activeMap[alias] = false;
                        return;
                    }
                    _this.activeMap[alias] = true;
                }));
            };
            var this_1 = this;
            for (var _i = 0, _a = Object.keys(this.flatMap); _i < _a.length; _i++) {
                var alias = _a[_i];
                _loop_1(alias);
            }
        },
        unsubscribe: function () {
            var fn;
            for (var _i = 0, _a = this.subscriptions; _i < _a.length; _i++) {
                fn = _a[_i];
                fn();
            }
        },
    },
    created: function () {
        this.initMediaQueries();
    },
    beforeDestroy: function () {
        this.unsubscribe();
    },
    render: function (createElement) {
        var ctx = Object.assign({}, this.context);
        if (!this.$scopedSlots.default) {
            if ((this.$slots.default || []).length > 1) {
                return createElement("div", this.$slots.default);
            }
            return (this.$slots.default || [])[0];
        }
        var scoped = this.$scopedSlots.default(ctx);
        if (this.$slots.default) {
            return createElement("div", this.$slots.default.concat([scoped]));
        }
        return scoped;
    },
});

var BreakpointPlugin = {
    name: "BreakpointPlugin",
    install: function (Vue$$1, mqm) {
        if (mqm === void 0) { mqm = Bootstrap4Grid(); }
        var flatMap = FlattenMediaQueryMap(mqm);
        var Rx = new Vue$$1({
            data: Object.keys(flatMap).reduce(function (map, alias) {
                map[alias] = false;
                return map;
            }, {}),
        });
        var _loop_1 = function (alias) {
            SubscribeToMediaQuery(flatMap[alias], function (mql) {
                if (!mql.matches) {
                    Rx.$data[alias] = false;
                    return;
                }
                Rx.$data[alias] = true;
            });
        };
        for (var _i = 0, _a = Object.keys(flatMap); _i < _a.length; _i++) {
            var alias = _a[_i];
            _loop_1(alias);
        }
        Vue$$1.component("breakpoint", Vue$$1.extend({
            computed: {
                context: function () {
                    return Rx.$data;
                },
            },
            render: function (createElement) {
                var ctx = Object.assign({}, this.context);
                if (!this.$scopedSlots.default) {
                    if ((this.$slots.default || []).length > 1) {
                        return createElement("div", this.$slots.default);
                    }
                    return (this.$slots.default || [])[0];
                }
                var scoped = this.$scopedSlots.default(ctx);
                if (this.$slots.default) {
                    return createElement("div", this.$slots.default.concat([scoped]));
                }
                return scoped;
            },
        }));
    },
};

export { BreakpointComponent, BreakpointPlugin };
